module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pagination d-flex justify-content-end align-items-center"
  }, [_c('span', {
    staticClass: "pointer",
    class: _vm.isFirstPage() ? 'disabled' : '',
    on: {
      "click": function($event) {
        _vm.firstPage();
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-step-backward fa-lg"
  })]), _vm._v(" "), _c('span', {
    staticClass: "pointer ml-3",
    class: _vm.isFirstPage() ? 'disabled' : '',
    on: {
      "click": function($event) {
        _vm.previousPage();
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left fa-lg"
  })]), _vm._v(" "), _c('span', {
    staticClass: "ml-3 page-numbers"
  }, [_vm._v(" " + _vm._s(_vm.itemPagination.currentPage + 1) + " / " + _vm._s(_vm.itemPagination.totalPages + 1) + " ")]), _vm._v(" "), _c('span', {
    staticClass: "pointer ml-3",
    class: _vm.isLastPage() ? 'disabled' : '',
    on: {
      "click": function($event) {
        _vm.nextPage();
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-right fa-lg"
  })]), _vm._v(" "), _c('span', {
    staticClass: "pointer ml-3",
    class: _vm.isLastPage() ? 'disabled' : '',
    on: {
      "click": function($event) {
        _vm.lastPage();
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-step-forward fa-lg"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2a180f2d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tools/DefaultPagination.vue
// module id = 3093
// module chunks = 0